<div class="additional-info">
  <ng-content></ng-content>
</div>
